// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const EmbeddedWidgetValues = {
   activeTab: 'widget-type',
   activeWidget:'',
   showEmbeddedWidgetsBox: false
}

const CitationValues = {options: {}}

angular.module('summonApp.values')
   .value('embeddedWidgetValues', EmbeddedWidgetValues)
   .value('citationValues', CitationValues)
